import { sectionSchema } from "../../../lib";
import { useRequestQuery } from "../../../request";
import { keyRecommendations } from "./keyRecommendations";

export const useRequestRecommendations = () => ({
  query: useRequestQuery<typeof sectionSchema>({
    queryFnRequestProps: {
      urlBackendPath: "/me/recommendations/winback/web",
      schema: sectionSchema,
    },
    queryKey: keyRecommendations(),
  }),
});
